import React from "react";
import { Link } from "react-router-dom";
import ClientPortalLayout from "./ClientPortalLayout";

const ClientNotificationsPage = () => {
  return (
    <ClientPortalLayout
      activeKey="notifications"
      title="Notifications"
      subtitle="View dashboard alerts, email updates, and WhatsApp workflow messages."
      actions={<Link className="btn btn-light" to="/client-dashboard">Dashboard</Link>}
    >
      <article className="table-panel">
        <div className="search-row">
          <input type="text" placeholder="Search by type, notice id, status" />
          <select><option>All Channels</option><option>Dashboard</option><option>Email</option><option>WhatsApp</option></select>
          <select><option>All Status</option><option>Unread</option><option>Read</option></select>
        </div>
        <div className="table-scroll">
          <table className="crud-table">
            <thead><tr><th>Notification ID</th><th>Channel</th><th>Notice ID</th><th>Message</th><th>Date</th><th>Status</th></tr></thead>
            <tbody>
              <tr><td>NTF-7001</td><td>Dashboard</td><td>LN-2034</td><td>Advocate requested additional ID proof</td><td>2026-03-02</td><td>Unread</td></tr>
              <tr><td>NTF-7002</td><td>Email</td><td>LN-2034</td><td>Draft generated successfully</td><td>2026-03-01</td><td>Read</td></tr>
              <tr><td>NTF-7003</td><td>WhatsApp</td><td>LN-2028</td><td>Courier delivered the final legal notice</td><td>2026-03-01</td><td>Read</td></tr>
            </tbody>
          </table>
        </div>
      </article>
      <div className="pagination-wrap"><p className="pagination-meta">Showing 1-25 of 300</p><div className="pagination"><span className="page-btn active">1</span><span className="page-btn">2</span><span className="page-btn">3</span><span className="page-btn">...</span><span className="page-btn">16</span></div></div>
    </ClientPortalLayout>
  );
};

export default ClientNotificationsPage;
